import { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const MobileDateCarousel = ({ events, onDateSelect, selectedDate }) => {
    const [dateRange, setDateRange] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        generateDateRange();
    }, [selectedDate]);

    const generateDateRange = () => {
        const dates = [];
        const today = new Date(selectedDate);

        for (let i = -3; i <= 3; i++) {
            const date = new Date(today);
            date.setDate(today.getDate() + i);
            dates.push(date);
        }

        setDateRange(dates);
    };

    const navigateDays = (direction) => {
        const newDate = new Date(selectedDate);
        newDate.setDate(selectedDate.getDate() + (direction === 'next' ? 7 : -7));
        onDateSelect(newDate);
    };

    const isToday = (date) => {
        const today = new Date();
        return date.toDateString() === today.toDateString();
    };

    const isSelected = (date) => {
        return date.toDateString() === selectedDate.toDateString();
    };

    const getEventsForDate = (date) => {
        return events.filter(event => {
            const eventDate = new Date(event.start);
            return eventDate.toDateString() === date.toDateString();
        });
    };

    const getEventColor = (event) => {
        if (event.activity?.startsWith("Planificat")) return "#801F26";
        if (event.activity?.startsWith("Raportat")) return "#285133";
        if (event.activity?.startsWith("Alte activitati Planificate")) return "#332851";
        if (event.activity?.startsWith("Alte activitati")) return "#DA9673";
        return "#666";
    };

    const getWeekRangeText = (date) => {
        const startOfWeek = new Date(date);
        const dayOfWeek = startOfWeek.getDay();
        const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
        startOfWeek.setDate(date.getDate() + diffToMonday);

        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(startOfWeek.getDate() + 6);

        return `Săptămâna ${startOfWeek.getDate()}-${endOfWeek.getDate()} ${startOfWeek.toLocaleDateString('ro-RO', { month: 'long' })} ${startOfWeek.getFullYear()}`;
    };

    const hanldeOnSelectEvent = (e) => {
        console.log(e)
        if (e.activity === "Planificat") {
            confirmDelete(e)
        } else if (e.activity === "Raportat") {
            confirmDelete2(e)
        }
        else if (e.activity === "Alte activitati") {
            confirmDelete3(e)
        }
    };

    const confirmDelete = async (item) => {
        navigate("/planning/reportplanning", { state: { item } });
    };

    const confirmDelete2 = async (item) => {
        navigate("/reporting/viwereporting", { state: { item } });
    };

    const confirmDelete3 = async (item) => {
        navigate("/otheractivity/viweotheractivity", { state: { item } });
    };

    return (
        <div className="lg:hidden bg-white dark:bg-gray-800 shadow-lg border-b border-gray-200 dark:border-gray-700">
            <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 dark:border-gray-700">
                <button
                    onClick={() => navigateDays('prev')}
                    className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-colors"
                >
                    <ChevronLeft className="w-5 h-5 text-gray-600 dark:text-gray-300" />
                </button>

                <h3 className="text-lg font-semibold text-gray-800 dark:text-white">
                    {getWeekRangeText(selectedDate)}
                </h3>

                <button
                    onClick={() => navigateDays('next')}
                    className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-colors"
                >
                    <ChevronRight className="w-5 h-5 text-gray-600 dark:text-gray-300" />
                </button>
            </div>

        <div className="flex gap-2 px-3 py-3 overflow-x-auto scrollbar-hide">
    {dateRange.map((date, index) => {
        const dateEvents = getEventsForDate(date);
        const isCurrentDay = isToday(date);
        const isActive = isSelected(date);

        return (
            <button
                key={index}
                onClick={() => onDateSelect(date)}
                className={`
                    flex flex-col items-center justify-start p-2 rounded-xl border-2 transition-all 
                    flex-1 min-w-[60px] max-w-[120px] /* Dimensiuni minime și maxime */
                    ${isActive
                        ? 'border-blue-500 bg-blue-500 text-white shadow-lg transform scale-105'
                        : 'border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200'
                    }
                    ${isCurrentDay && !isActive ? 'border-blue-300 bg-blue-50 dark:bg-blue-900/20' : ''}
                `}
                style={{ 
                    flexBasis: `${100 / dateRange.length}%`, /* Distribuie egal spațiul */
                    flexGrow: 1,
                    flexShrink: 1 
                }}
            >
                {/* Conținutul rămâne la fel */}
                {dateEvents.length > 0 && (
                    <div className="flex justify-center mb-1 space-x-1">
                        {dateEvents.slice(0, 3).map((event, eventIndex) => (
                            <div
                                key={eventIndex}
                                className="w-2 h-2 rounded-full flex-shrink-0"
                                style={{ backgroundColor: getEventColor(event) }}
                            />
                        ))}
                        {dateEvents.length > 3 && (
                            <div className="w-2 h-2 rounded-full bg-gray-400 flex-shrink-0" />
                        )}
                    </div>
                )}

                <span className="text-xs font-medium uppercase truncate w-full text-center">
                    {date.toLocaleDateString('ro-RO', { weekday: 'short' })}
                </span>

                <span className={`
                    font-bold text-lg
                    ${isActive ? 'text-white' : ''}
                `}>
                    {date.getDate()}
                </span>

                <span className="text-xs opacity-75 truncate w-full text-center">
                    {date.toLocaleDateString('ro-RO', { month: 'short' })}
                </span>

                {dateEvents.length > 0 && (
                    <div className={`
                        mt-1 px-2 py-1 rounded-full text-xs font-medium min-w-[24px] flex-shrink-0
                        ${isActive
                            ? 'bg-white text-blue-600'
                            : 'bg-blue-100 dark:bg-blue-900 text-blue-600 dark:text-blue-300'
                        }
                    `}>
                        {dateEvents.length}
                    </div>
                )}
            </button>
        );
    })}
</div>

            <div className="border-t border-gray-200 dark:border-gray-700">
                <div className="px-4 py-3">
                    <h4 className="text-sm font-semibold text-gray-600 dark:text-gray-300 mb-3">
                        Evenimente pentru această zi:
                    </h4>

                    {getEventsForDate(selectedDate).length === 0 ? (
                        <div className="text-center py-4 text-gray-500 dark:text-gray-400">
                            Nu există evenimente pentru această zi
                        </div>
                    ) : (
                        <div className="space-y-2">
                            {getEventsForDate(selectedDate).map((event, index) => (
                                <div
                                    onClick={() => hanldeOnSelectEvent(event)}
                                    key={index}
                                    className="flex items-start p-3 rounded-lg border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-700"
                                >
                                    <div
                                        className="w-3 h-3 rounded-full mt-1 flex-shrink-0"
                                        style={{ backgroundColor: getEventColor(event) }}
                                    />
                                    <div className="ml-3 flex-1">
                                        <h5 className="text-sm font-medium text-gray-800 dark:text-white">
                                            {event.title}
                                        </h5>
                                        <p className="text-xs text-gray-600 dark:text-gray-400 mt-1">
                                            {new Date(event.start).toLocaleTimeString('ro-RO', {
                                                hour: '2-digit',
                                                minute: '2-digit'
                                            })} - {new Date(event.end).toLocaleTimeString('ro-RO', {
                                                hour: '2-digit',
                                                minute: '2-digit'
                                            })}
                                        </p>
                                        {event.comment && (
                                            <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                                                {event.comment}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MobileDateCarousel;